// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recaptchabar .text{font-size:12px;font-size:var(--des-font-text-text-xs-size, 12px);line-height:16px;line-height:var(--des-font-text-text-xs-line-height, 16px);padding-inline:0;color:#d3d3d3;color:var(--des-color-fill-glyph-secondary, #d3d3d3);padding-block:1rem}.recaptchabar .text a{text-decoration:none;color:var(--des-color-fill-glyph-interaction-accent-rest);font-weight:var(--weight-bold)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
